import { createLucideIcon } from 'lucide-react';

export const StarSolid = createLucideIcon('StarSolid', [
  [
    'path',
    {
      key: 'path-1',
      d: 'M12.1.7q.6 0 1 .5l2.8 6 6.5.9a1 1 0 0 1 .6 1.7l-4.7 4.6 1 6.4a1 1 0 0 1-1.4 1l-5.8-3-5.8 3a1 1 0 0 1-1.5-1L6 14.4 1.2 9.8A1 1 0 0 1 1.8 8l6.5-1 2.9-5.9a1 1 0 0 1 .9-.5',
      fill: 'currentColor',
      stroke: 'none',
      fillRule: 'evenodd',
    },
  ],
]);
